import { render, staticRenderFns } from "./memberGroupTab.vue?vue&type=template&id=0677f091&"
import script from "./memberGroupTab.vue?vue&type=script&lang=js&"
export * from "./memberGroupTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports